<template>
  <main class="py-5">
    <div class="space-y-5">
      <slot />
    </div>
  </main>
</template>
